import PropTypes from "prop-types";
import React from "react";

import { UrlProvider } from "../../../../../api/UrlProvider";
import withTranslations from "../../../../../hocs/withTranslations";
import {
  getStrategyDashboardI18nKey,
  getStrategyDashboardPageTitleKey,
  STRATEGY_DASHBOARD_TABS
} from "../../../../../lib/StrategyDashboard/strategyDashboardConfig";
import { useStrategyDashboardConfig } from "../../../../../lib/StrategyDashboard/StrategyDashboardContext";
import { Breadcrumbs } from "../../../common/Typography";

const StrategyDashboardBreadcrumb = ({ translate, locale, page }) => {
  const dashboard = useStrategyDashboardConfig();
  const dashboardUrl = UrlProvider.getLocalizedUrl(
    locale,
    `fe.${dashboard.web.urlPatternKeys.overview.component}`,
    { locale }
  );

  return (
    <Breadcrumbs
      items={[
        {
          label: translate(getStrategyDashboardI18nKey(dashboard, "page_title")),
          href: dashboardUrl
        },
        {
          label: translate(getStrategyDashboardPageTitleKey(dashboard, page))
        }
      ]}
    />
  );
};

StrategyDashboardBreadcrumb.propTypes = {
  page: PropTypes.oneOf(Object.values(STRATEGY_DASHBOARD_TABS)).isRequired
};

export default withTranslations(StrategyDashboardBreadcrumb);
